import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Schedule() {
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/schedule`)
      .then(r => setDays(r.data))
      .catch(() => setDays([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
        ::  Weekly Programme  ::
      </div>
      <h1 className="font-display text-6xl md:text-8xl mt-4">SCHEDULE</h1>
      <p className="font-mono-r text-xs md:text-sm tracking-[0.25em] uppercase opacity-70 mt-3">
        All times London / GMT
      </p>

      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>

      {loading && <div className="font-mono-r text-xs opacity-70">Loading schedule…</div>}

      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
        {days.map((d) => (
          <div key={d.day} className="hairline p-5 text-left" data-testid={`schedule-day-${d.day.toLowerCase()}`}>
            <div className="flex items-baseline justify-between hairline-b pb-3">
              <h3 className="font-display text-3xl">{d.day}</h3>
              <span className="font-mono-r text-[10px] tracking-[0.3em] uppercase opacity-60">{d.slots.length} slots</span>
            </div>
            <ul className="mt-3 space-y-2">
              {d.slots.map((s) => (
                <li key={`${s.time}-${s.show}`} className="flex items-baseline justify-between font-mono-r text-sm">
                  <span className="opacity-70 tabular-nums">{s.time}</span>
                  <span className="flex-1 mx-3 border-b border-dotted border-white opacity-30 translate-y-[-3px]" />
                  <span className="uppercase tracking-[0.15em]">{s.show}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
